import FondoDashboard from "../../images/bg-dashboard.jpg";
import {
  ClientComponent,
  ClientAdministratorComponent,
  AdministratorComponent,
} from "./components";
import { useLocation, useOutlet } from "react-router-dom";
import React from "react";
import { LoadingPage } from "../Loading";
import { usersGetbyToken } from "../../../libs/apis";
import { useRouterStore } from "../../../libs/stores";
import { message } from "antd";
import {
  getValidRoutes,
  extractModuleBase,
  findClosestModuleByPath,
  normalizePath,
} from "../../../libs/helpers";

const Dashboard = () => {
  const typeDashboardCode = useRouterStore((state) => state.typeDashboardCode);
  const location = useLocation();

  // OPTIMIZACIÓN: Solo obtener lo que necesitamos del store
  const validateModulesFromApi = useRouterStore(
    (state) => state.validateModulesFromApi
  );
  const setOptions = useRouterStore((state) => state.setOptions);

  // OPTIMIZACIÓN: Usar selectors específicos para evitar re-renders
  const modules = useRouterStore((state) => state.modules);

  const options = useRouterStore((state) => state.options);

  const previousModuleBase = useRouterStore(
    (state) => state.previousModuleBase
  );
  const setPreviousModuleBase = useRouterStore(
    (state) => state.setPreviousModuleBase
  );

  // OPTIMIZACIÓN: Memoizar validRoutes
  const validRoutesMap = React.useMemo(() => getValidRoutes(), []);

  // OPTIMIZACIÓN: Estado local para controlar cuándo validar
  const [hasValidatedInitially, setHasValidatedInitially] =
    React.useState(false);

  // OPTIMIZACIÓN: Memoizar la función de validación de usuario
  const handleValidate = React.useCallback(async () => {
    try {
      await usersGetbyToken();
    } catch (err: any) {
      message.error(err.toString());
    }
  }, []);

  // OPTIMIZACIÓN: Separar la validación inicial de la actualización de opciones
  React.useEffect(() => {
    if (!hasValidatedInitially) {
      const initializeApp = async () => {
        await handleValidate();
        if (modules.length === 0) {
          await validateModulesFromApi();
        }
        setHasValidatedInitially(true);
      };
      initializeApp();
    }
  }, [
    hasValidatedInitially,
    handleValidate,
    validateModulesFromApi,
    modules.length,
  ]);

  // OPTIMIZACIÓN: Actualizar opciones cuando cambie la ruta o módulos
  React.useEffect(() => {
    if (!hasValidatedInitially || modules.length === 0) return;

    const currentPath = location.pathname;
    const moduleBase = extractModuleBase(currentPath);

    // Actualizar el módulo base actual
    if (previousModuleBase !== moduleBase) {
      setPreviousModuleBase(moduleBase);
    }

    const updateOptions = () => {
      const closestModule = findClosestModuleByPath(
        modules,
        normalizePath(currentPath)
      );


      if (closestModule?.options?.length) {
        const validRoutes = validRoutesMap[closestModule.to] || new Set();
        const validOptions = closestModule.options.filter((option) =>
          validRoutes.size > 0 ? validRoutes.has(option.to) : true
        );


        // Siempre actualizar las opciones para asegurar que se muestren
        setOptions(validOptions);
      } else {
        setOptions([]);
      }
    };

    // Usar setTimeout para asegurar que la actualización se ejecute después del render
    const timer = setTimeout(() => {
      updateOptions();
    }, 50);

    return () => clearTimeout(timer);
  }, [
    location.pathname,
    modules,
    hasValidatedInitially,
    validRoutesMap,
    setOptions,
    setPreviousModuleBase,
    previousModuleBase,
  ]);

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        overflowY: "hidden",
        backgroundImage: `url(${FondoDashboard})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      {typeDashboardCode === "DASHBOARD_CLIENT" ? (
        <ClientComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_CLIENT_ADMINISTRATOR" ? (
        <ClientAdministratorComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_ADMINISTRATOR" ? (
        <AdministratorComponent options={options} />
      ) : null}
    </div>
  );
};

export default Dashboard;
